import { render, staticRenderFns } from "./ProcessGroup.vue?vue&type=template&id=406b9c2c&"
import script from "./ProcessGroup.vue?vue&type=script&lang=js&"
export * from "./ProcessGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports